import { useQuery } from '@tanstack/react-query';

import { catalogService } from '../services/catalog.service';
/**
 * Recupera los valores de un catálogo especificado
 *
 * @param {string} id Identificador del catálogo por recuperar
 * @return {*} lista de valores asociados con el catálogo del catálogo
 */
export const useCatalogValueList = (id: string) => {
  return useQuery({
    queryKey: ['catalogValue', id],
    queryFn: () => catalogService.listCatalogValues(id)
  });
};
